export class BackupZeroEtlAwsGlueCatalogConfiguration {
    'awsAccountId';
    'awsRegion';
    'iamRoleArn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsAccountId",
            "baseName": "awsAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "awsRegion",
            "baseName": "awsRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "iamRoleArn",
            "baseName": "iamRoleArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlAwsGlueCatalogConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
